import icon from "../assets/logo.svg";
import { Link } from "react-router-dom";
import { useState } from "react";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="jakarta shadow-sm border-b border-[#e8e8e8] w-full overflow-hidden" style={{ backgroundColor: "#F4F4F4" }}>
      <div className="container mx-auto flex items-center py-5 max-w-7xl sm:px-4 px-2 w-full">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img src={icon} alt="Logo" className="md:h-9 sm:h-8 h-7 w-auto" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-8 text-[#434343] font-medium ml-12 flex-shrink-0">
          <a
            href="https://humd.ae"
            className="hover:text-green-600 transition-colors text-md"
            target="_blank"
            rel="noopener noreferrer"
          >
            Marketplace
          </a>
          <a
            href="https://enterprise.humd.ae"
            className="hover:text-green-600 transition-colors text-md"
            target="_blank"
            rel="noopener noreferrer"
          >
            Enterprise
          </a>
          <a
            href="https://humd.ae/about"
            className="hover:text-green-600 transition-colors text-md"
            target="_blank"
            rel="noopener noreferrer"
          >
            About
          </a>
          <a
            href="https://humd.ae/contact"
            className="hover:text-green-600 transition-colors text-md"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact
          </a>
        </nav>

        {/* Right Side */}
        <div className="ml-auto flex items-center gap-3 flex-shrink-0">
          {/* Desktop Shop Now */}
          <div className="hidden md:block">
            <a
              href="https://humd.ae"
              className="flex items-center gap-2 px-5 py-1.5 rounded-full font-semibold text-white transition-opacity hover:opacity-90"
              style={{ backgroundColor: "#2F9E5C" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Shop Now
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>

          {/* Desktop Enterprise */}
          <div className="hidden md:block">
            <a
              href="https://enterprise.humd.ae"
              className="flex items-center gap-2 px-5 py-1.5 rounded-full font-semibold border transition hover:opacity-80"
              style={{ color: "#2B894F", borderColor: "#2B894F" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Enterprise
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>

          {/* Hamburger - Mobile Only */}
          <button
            className="md:hidden inline-flex items-center justify-center p-1 rounded-md border border-gray-300 text-gray-700"
            onClick={() => setIsOpen((prev) => !prev)}
            aria-label="Toggle navigation"
          >
            <svg
              className={`${isOpen ? "hidden" : "block"}`}
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path d="M4 7H20M4 12H20M4 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <svg
              className={`${isOpen ? "block" : "hidden"}`}
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Dropdown */}
      <div
        className={`md:hidden px-6 transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-96 opacity-100 py-4" : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div className="flex flex-col space-y-2 text-gray-800 font-medium">
          <a href="https://humd.ae" target="_blank" rel="noopener noreferrer" className="hover:text-green-600 transition-colors text-lg">
            Marketplace
          </a>
          <a href="https://enterprise.humd.ae" target="_blank" rel="noopener noreferrer" className="hover:text-green-600 transition-colors text-lg">
            Enterprise
          </a>
          <a href="https://humd.ae/about" target="_blank" rel="noopener noreferrer" className="hover:text-green-600 transition-colors text-lg">
            About
          </a>
          <a href="https://humd.ae/contact" target="_blank" rel="noopener noreferrer" className="hover:text-green-600 transition-colors text-lg">
            Contact
          </a>
          <a
            href="https://humd.ae"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 flex items-center gap-2 px-5 py-1.5 rounded-full font-semibold text-white w-max"
            style={{ backgroundColor: "#2F9E5C" }}
          >
            Shop Now
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
          <a
            href="https://enterprise.humd.ae"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-5 py-1.5 rounded-full font-semibold border w-max"
            style={{ color: "#2B894F", borderColor: "#2B894F" }}
          >
            Enterprise
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
